import { RecordStatus } from './record-status.enum';

export interface AlertsQueueItem {
  id: string;
  status: RecordStatus;
  createdAt: Date;
  chargingZoneAlertId: string;
  alertType: AlertType;
  chargePointId: string | null;
  sessionId: string | null;
  vehicleId: string | null;
  chargingZoneAlert: {
    showOnDashboard: boolean;
    showOnMapScreen: boolean;
    showOnChargePointsScreen: boolean;
  };
  session: {
    vehicleDescription: string | null;
  };
}

export enum AlertType {
  ChargeSessionFinishedBelowSoc = 'charge_session_finished_below_soc',
  UnavailableChargePoint = 'unavailable_charge_point',
  LowAutonomy = 'low_autonomy',
  InsufficientSoc = 'insufficient_soc',
  LowBatteryAtStartUp = 'low_battery_at_start_up',
}
